<template>
    <div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div
            v-for="(i18nKey, key) in params.i18nKeys"
            :key="key"
            :class="{ 'font-weight-light': key !== 0 }"
            v-html="$t(i18nKey)"></div>
    </div>
</template>
<script>
export default {
    name: 'MultiLinesHeader',
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
};
</script>
<style lang="scss">
.ag-header-cell-comp-wrapper {
    justify-content: center;
}
</style>
